<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.fileManagement')"
    width="780px"
    :close-on-click-modal="false"
  >
    <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="files"
        :show-side-bar="false"
        style="width:100%"
      />
    </div>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </el-dialog>
</template>

<script>
import pdf from 'vue-pdf'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'

export default {
  name: 'FileManageDialog',
  components: { pdf, CargoDialog, preViewFileDialog },
  props: {
    visible: { type: Boolean, required: true },
    files: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Partners.FileName'),
          field: 'fileName',
          suppressMenu: true,
          width: 175
        },
        {
          headerName: this.$t('Partners.FileType'),
          field: 'fileType',
          suppressMenu: true,
          width: 120,
          valueFormatter: params => {
            const arr = params.data.fileName.split('.')
            if (arr.length > 1) {
              return arr[arr.length - 1].toLowerCase()
            }
            return ''
          }
        },
        {
          headerName: this.$t('Partners.FileSize'),
          field: 'fileSize',
          suppressMenu: true,
          width: 120,
          valueFormatter: params => {
            return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('Partners.Uploader'),
          field: 'userId',
          suppressMenu: true,
          width: 120,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Partners.UploadTime'),
          field: 'createTime',
          suppressMenu: true,
          width: 120,
          valueFormatter: params => {
            return params.value ? ColumnUtils.dateLabelFunc(params.value) : ''
          }
        },
        {
          headerName: this.$t('FileHistory.operation'),
          field: 'fileId',
          colId: 'operation',
          width: 120,
          cellRenderer: params => {
            if (params.value) {
              let preview = ''
              const fileStr = params.data.fileName
              const location = fileStr.lastIndexOf('.')
              const type = fileStr.substring(location + 1, fileStr.length)
              if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'gif' || type === 'webp' || type === 'pdf' ||
              type === 'doc' || type === 'docx' || type === 'xls' || type === 'xlsx') {
                const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
                preview = `<a onclick="${handlePreviewFile}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
              }
              return `<a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.user.sessionId}" target="_blank" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_Download')}
                    </a>` + preview
            } else {
              return ''
            }
          }
        }
      ],
      documentManage: new DocumentManage(),
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.user = cache.user
    this.storageURL = cache.config.get('StorageURL')
  },
  beforeMount() {
    const context = this
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async handlePreviewFile(value) {
      const fileObject = this.files.find(x => x.fileId === value)
      this.previewFileData.file = fileObject || null
      this.previewFileData.visible = true
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    }
  }
}
</script>
